module.exports = __webpack_public_path__ + "static/media/lingolink-2.d0457e60.jpg";